import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router';
import {
  Button,
  CircularProgress,
  Stack,
  Typography,
} from '@rossum/ui/material';
import { asScalar, parse } from '../../../lib/url';
import { SSO_POPUP_TOKEN_KEY } from '../ssoPopupHandoff';

export const SSORelay = () => {
  const intl = useIntl();
  const location = useLocation();
  const parsedSearch = parse(location.search);
  const providerUrl = asScalar(parsedSearch['url']);

  useEffect(() => {
    if (!providerUrl) {
      return undefined;
    }

    const handleStorage = (event: StorageEvent) => {
      if (event.key === SSO_POPUP_TOKEN_KEY && event.newValue) {
        window.opener?.postMessage(
          { type: 'sso-token', token: event.newValue },
          window.location.origin
        );
        window.close();
      }
    };

    window.addEventListener('storage', handleStorage);

    return () => {
      window.removeEventListener('storage', handleStorage);
    };
  }, [providerUrl]);

  const [clicked, setClicked] = useState<boolean>(false);

  return (
    <Stack alignItems="center" justifyContent="center" sx={{ height: '100vh' }}>
      {!clicked ? (
        <Button
          onClick={() => {
            setClicked(true);
            window.open(providerUrl!, 'sso-idp', 'width=500,height=600');
          }}
          variant="outlined"
        >
          {intl.formatMessage({ id: 'containers.login.sso.relay.confirm' })}
        </Button>
      ) : (
        <>
          <CircularProgress />
          <Typography sx={{ mt: 2 }}>
            {intl.formatMessage({
              id: 'containers.login.sso.relay.waiting',
            })}
          </Typography>
        </>
      )}
    </Stack>
  );
};
